import { ApiService } from '~/shared/api'
import type { EmployersTaskDto } from '~/models/employers-tasks'
import type { AxiosResponse } from 'axios'

interface EmployersTaskListResponse {
  data?: unknown[]
}

export class EmployersTaskService extends ApiService {
  readonly urls = {
    list: '/api/v1/yavagro/assignment/query',
    sendForm: '/api/v1/yavagro/assignment/store',
  }

  public async getList(
    params?: Record<string, string | number>
  ): Promise<EmployersTaskListResponse> {
    const res = await this.http.request<EmployersTaskListResponse>({
      url: this.urls.list,
      params,
    })

    return res.data
  }

  sendForm(dto: EmployersTaskDto): Promise<AxiosResponse> {
    return this.http.request({
      data: dto,
      method: 'POST',
      url: this.urls.sendForm,
      silent: true,
    })
  }
}
